export enum BudgetStateColumn {
    BUDGET = 'budget',
    EXERCISE = 'exercise',
    PHASE = 'phase',
}

export type BudgetProposalRow = {
    budget: string;
    exercise: number;
    phase: string;
    redirectTo: string;
};
